import { LoggedUserResponse } from '@/core/services/loggedUserService.ts'

export const userInfo: { data: LoggedUserResponse; message: string } = {
  message: 'OK',
  data: {
    id: 2,
    email: 'ynascolopez@gmail.com',
    name: 'Juan',
    lastName: 'Pablo',
    ally: 'Esta gente',
    tokenIntercom: 'ddh',
    roles: [
      {
        id: 3,
        name: 'Administrador'
      }
    ],
    permissions: [
      'INVENTORY_AUTOMOTIVE_INVENTORY:CREAR',
      'INVENTORY_AUTOMOTIVE_INVENTORY:ACTUALIZAR',
      'INVENTORY_AUTOMOTIVE_INVENTORY:ELIMINAR',
      'SERVICES_DAILY_CUT:EXPORTAR',
      'ALLY_DIRECT_RECHARGE:LEER',
      'ALLY_DIRECT_RECHARGE:ACTUALIZAR',
      'ALLY_DIRECT_RECHARGE:RECARGAR',
      'ALLY_DIRECT_RECHARGE:REPORTAR',
      'SALES_CLIENTS:BUSQUEDA',
      'SETTINGS_LOCATION:ACTUALIZAR',
      'ALLY_PAYMENT_REQUESTS:EXPORTAR',
      'ALLY_BANK_ACCOUNTS:ADMIN',
      'REPORTS_ZONA_U_SALES:EXPORTAR',
      'REPORTS_ZONA_U_SALES:LEER',
      'REPORTS_CLUB_MOVISTAR_SALES:LEER',
      'REPORTS_CLUB_MOVISTAR_SALES:EXPORTAR',
      'REPORTS_PREASSIGNED_CREDIT_SUMMARY:LEER',
      'REPORTS_PREASSIGNED_CREDIT_SUMMARY:EXPORTAR',
      'REPORTS_CREDIT_REFINANCING:LEER',
      'REPORTS_CREDIT_REFINANCING:EXPORTAR',
      'REPORTS_WEPPA_PLUS:LEER',
      'REPORTS_WEPPA_PLUS:EXPORTAR',
      'REPORTS_PENDING_PRODUCTS:LEER',
      'REPORTS_PENDING_PRODUCTS:EXPORTAR',
      'REPORTS_BRANCHES_RECHARGED:LEER',
      'REPORTS_BRANCHES_RECHARGED:EXPORTAR',
      'REPORTS_ALLIES_RECHARGED:LEER',
      'REPORTS_ALLIES_RECHARGED:EXPORTAR',
      'REPORTS_ALLIES_PENDING:LEER',
      'REPORTS_ALLIES_PENDING:EXPORTAR',
      'REPORTS_APPLE_PENDING:LEER',
      'REPORTS_APPLE_PENDING:EXPORTAR',
      'REPORTS_ALLIES_PAYMENT:LEER',
      'REPORTS_ALLIES_PAYMENT:EXPORTAR',
      'REPORTS_LOGS:LEER',
      'REPORTS_LOGS:EXPORTAR',
      'REPORTS_BRANCHES_DAYS_WHITOUT_SALES:LEER',
      'REPORTS_CASHOUT:LEER',
      'REPORTS_CASHOUT:PROCESAR',
      'REPORTS_CASHOUT:EXPORTAR',
      'REPORTS_MAPS:LEER',
      'REPORTS_ASSIGNED_MOTO:LEER',
      'REPORTS_ASSIGNED_MOTO:EXPORTAR',
      'REPORTS_COLLECTIONS:LEER',
      'REPORTS_COLLECTIONS:EXPORTAR',
      'REPORTS_RECHARGE_CASH:LEER',
      'REPORTS_RECHARGE_CASH:EXPORTAR',
      'SALES_CLIENTS:CREAR',
      'SALES_CLIENTS:LEER',
      'SALES_CLIENTS:ACTUALIZAR',
      'SALES_CLIENTS:ELIMINAR',
      'SALES_CLIENTS:ACTIVAR',
      'SALES_CLIENTS:SENSIBLE',
      'SALES_CLIENTS:VALIDAR MOVISTAR',
      'SALES_CLIENTS:VALIDAR ZONA U',
      'SALES_CLIENTS:DOCUMENTOS',
      'REPORTS_RECHARGE_INVOICES:LEER',
      'REPORTS_RECHARGE_INVOICES:EXPORTAR',
      'SALES_PRODUCTS:ASIGNAR',
      'SALES_PRODUCTS:REASIGNAR',
      'SALES_PRODUCTS:LEER',
      'SALES_PRODUCTS:ACTUALIZAR',
      'SALES_PRODUCTS:ELIMINAR',
      'SALES_PRODUCTS:REFINANCIAR',
      'SALES_PRODUCTS:LIBERAR',
      'SALES_PRODUCTS:SENSIBLE',
      'SALES_PRODUCTS:CAMBIAR',
      'SALES_PRODUCTS:RESTABLECER CLAVE',
      'SALES_PRODUCTS:LIBERAR TEMPORAL',
      'SALES_COMPATIBLE:LEER',
      'SALES_TOOLBOX:DESINSTALAR',
      'SALES_TOOLBOX:CALCULADORA',
      'SALES_WALLET:LEER',
      'SALES_WALLET:RECARGAR',
      'COLLECTIONS_OVERDUE_QUOTES:LEER',
      'COLLECTIONS_OVERDUE_QUOTES:BLOQUEAR',
      'ALLY_PAYMENT_REQUESTS:LEER',
      'ALLY_PAYMENT_REQUESTS:ACTUALIZAR',
      'ALLY_DAILY_CUT:LEER',
      'ALLY_DAILY_CUT:EXPORTAR',
      'ALLY_MONTHLY_CUT:LEER',
      'ALLY_MONTHLY_CUT:EXPORTAR',
      'ALLY_MONTHLY_CUT:FACTURAR',
      'COLLECTIONS_PENDING_RECHARGE:LEER',
      'COLLECTIONS_PENDING_RECHARGE:PAGAR',
      'COLLECTIONS_PENDING_RECHARGE:ACTUALIZAR',
      'SUPPORT_UPDATING_CLIENT:LEER',
      'SUPPORT_UPDATING_CLIENT:ACTUALIZAR',
      'SUPPORT_UPDATING_CLIENT:ELIMINAR',
      'SUPPORT_RELEASE_WARRANTY:LEER',
      'SUPPORT_RELEASE_WARRANTY:ACTUALIZAR',
      'SUPPORT_RELEASE_WARRANTY:ELIMINAR',
      'SUPPORT_UPDATING_PRODUCT:LEER',
      'SUPPORT_UPDATING_PRODUCT:ACTUALIZAR',
      'SUPPORT_UPDATING_PRODUCT:ELIMINAR',
      'SUPPORT_CHANGING_PRODUCT:LEER',
      'SUPPORT_CHANGING_PRODUCT:ACTUALIZAR',
      'SUPPORT_CHANGING_PRODUCT:ELIMINAR',
      'SUPPORT_REASSIGN_PRODUCT:LEER',
      'SUPPORT_REASSIGN_PRODUCT:ACTUALIZAR',
      'SUPPORT_REASSIGN_PRODUCT:ELIMINAR',
      'SUPPORT_DELETING_PRODUCT:LEER',
      'SUPPORT_DELETING_PRODUCT:ACTUALIZAR',
      'SUPPORT_DELETING_PRODUCT:ELIMINAR',
      'TEACHING_VIDEO_CATEGORY:CREAR',
      'TEACHING_VIDEO_CATEGORY:LEER',
      'TEACHING_VIDEO_CATEGORY:ACTUALIZAR',
      'TEACHING_VIDEO_CATEGORY:ELIMINAR',
      'TEACHING_VIDEO:CREAR',
      'TEACHING_VIDEO:LEER',
      'TEACHING_VIDEO:ACTUALIZAR',
      'TEACHING_VIDEO:ELIMINAR',
      'SETTINGS_USERS:CREAR',
      'SETTINGS_USERS:LEER',
      'SETTINGS_USERS:ACTUALIZAR',
      'SETTINGS_USERS:ELIMINAR',
      'SETTINGS_USERS:ACTIVAR',
      'SETTINGS_CATEGORIES:LEER',
      'SETTINGS_CATEGORIES:ACTUALIZAR',
      'SETTINGS_CATEGORIES:CREAR',
      'SETTINGS_CATEGORIES:ELIMINAR',
      'SETTINGS_LOCATION:LEER',
      'SETTINGS_BRAND_MODEL:CREAR',
      'SETTINGS_BRAND_MODEL:LEER',
      'SETTINGS_BRAND_MODEL:ACTUALIZAR',
      'SETTINGS_BRAND_MODEL:ACTIVAR',
      'SETTINGS_BRAND_MODEL:ELIMINAR',
      'SETTINGS_EXCHANGE:LEER',
      'SETTINGS_EXCHANGE:ACTUALIZAR',
      'SETTINGS_EXCHANGE:ELIMINAR',
      'SETTINGS_RENTABILITY:CREAR',
      'SETTINGS_RENTABILITY:LEER',
      'SETTINGS_RENTABILITY:ACTUALIZAR',
      'SETTINGS_RENTABILITY:ELIMINAR',
      'SETTINGS_BANK:CREAR',
      'SETTINGS_BANK:LEER',
      'SETTINGS_PUSH_NOTIFICATIONS:LEER',
      'SETTINGS_BANK:ACTUALIZAR',
      'SETTINGS_BANK:ELIMINAR',
      'SETTINGS_BANK:ACTIVAR',
      'SETTINGS_PAYMENT_TYPE:CREAR',
      'SETTINGS_PAYMENT_TYPE:LEER',
      'SETTINGS_PAYMENT_TYPE:ACTUALIZAR',
      'SETTINGS_PAYMENT_TYPE:ELIMINAR',
      'SETTINGS_PAYMENT_TYPE:ACTIVAR',
      'SETTINGS_ROLES_PERMISSION:CREAR',
      'SETTINGS_ROLES_PERMISSION:LEER',
      'SETTINGS_ROLES_PERMISSION:ACTUALIZAR',
      'SETTINGS_ROLES_PERMISSION:ELIMINAR',
      'SETTINGS_LEVELS:LEER',
      'SETTINGS_LEVELS:ACTUALIZAR',
      'SETTINGS_PUBLICITY:LEER',
      'SETTINGS_PUBLICITY:CREAR',
      'SETTINGS_PUBLICITY:ACTUALIZAR',
      'SETTINGS_PUBLICITY:ELIMINAR',
      'INVENTORY_APPLE_INVENTORY:CREAR',
      'INVENTORY_APPLE_INVENTORY:LEER',
      'INVENTORY_APPLE_INVENTORY:ACTUALIZAR',
      'INVENTORY_APPLE_INVENTORY:ACTIVAR',
      'INVENTORY_APPLE_INVENTORY:ELIMINAR',
      'INVENTORY_PRODUCT_INVENTORY:CREAR',
      'INVENTORY_PRODUCT_INVENTORY:LEER',
      'INVENTORY_PRODUCT_INVENTORY:ACTUALIZAR',
      'INVENTORY_PRODUCT_INVENTORY:ELIMINAR',
      'INVENTORY_AUTOMOTIVE_INVENTORY:LEER',
      'INVENTORY_AUTOMOTIVE_INVENTORY:ACTUALIZAR',
      'INVENTORY_AUTOMOTIVE_INVENTORY:ELIMINAR',
      'REPORTS_TOTAL_SALES:LEER',
      'REPORTS_TOTAL_SALES:EXPORTAR',
      'REPORTS_BRANCHES_SALES:LEER',
      'REPORTS_BRANCHES_SALES:EXPORTAR',
      'REPORTS_ALLIES_SALES:LEER',
      'REPORTS_ALLIES_SALES:EXPORTAR',
      'REPORTS_AUTOMATIC_PAYMENT:LEER',
      'REPORTS_AUTOMATIC_PAYMENT:EXPORTAR',
      'REPORTS_EMPLOYED_PAYMENT:LEER',
      'REPORTS_EMPLOYED_PAYMENT:EXPORTAR',
      'REPORTS_REFERRAL_CDDES:LEER',
      'REPORTS_REFERRAL_CDDES:EXPORTAR',
      'ALLY_ALLIES:CREAR',
      'ALLY_ALLIES:LEER',
      'ALLY_ALLIES:ACTUALIZAR',
      'ALLY_ALLIES:ELIMINAR',
      'ALLY_BRANCHES:CREAR',
      'ALLY_BRANCHES:LEER',
      'ALLY_BRANCHES:ACTUALIZAR',
      'ALLY_BRANCHES:ELIMINAR',
      'ALLY_BRANCHES:ACTIVAR',
      'ALLY_BANK_ACCOUNTS:CREAR',
      'ALLY_BANK_ACCOUNTS:LEER',
      'ALLY_BANK_ACCOUNTS:ACTUALIZAR',
      'ALLY_BANK_ACCOUNTS:ELIMINAR',
      'ALLY_COMMISSIONS_BY_PRODUCT_TYPE:LEER',
      'ALLY_COMMISSIONS_BY_PRODUCT_TYPE:ACTUALIZAR',
      'ALLY_ASSIGN_MISCELLANEOUS:LEER',
      'ALLY_ASSIGN_MISCELLANEOUS:ACTUALIZAR',
      'ALLY_TRADEMARK:CREAR',
      'ALLY_TRADEMARK:LEER',
      'ALLY_TRADEMARK:ACTUALIZAR',
      'ALLY_TRADEMARK:ELIMINAR',
      'ALLY_PAYMENT_FREQUENCY:LEER',
      'ALLY_PAYMENT_FREQUENCY:ACTUALIZAR',
      'ALLY_BALANCE_RETENTION:LEER',
      'ALLY_BALANCE_RETENTION:ACTUALIZAR',
      'ALLY_ALLY_DAILY_CUT:LEER',
      'ALLY_ALLY_WALLET:LEER',
      'ALLY_ALLY_WALLET:RECARGAR',
      'ALLY_ALLY_WALLET:EXPORTAR',
      'ALLY_ALLOW_NEGATIVE_BALANCE_COLLECTION:LEER',
      'ALLY_ALLOW_NEGATIVE_BALANCE_COLLECTION:ACTUALIZAR',
      'REPORTS_OVERDUE_QUOTES_LIST:LEER',
      'REPORTS_OVERDUE_QUOTES_LIST:EXPORTAR',
      'SETTINGS_IMPORTS:LEER',
      'SETTINGS_PROMOTIONS:CREAR',
      'SETTINGS_PROMOTIONS:LEER',
      'SETTINGS_PROMOTIONS:ACTUALIZAR',
      'SETTINGS_PROMOTIONS:ELIMINAR',
      'ALLY_ALLY_CONFIGURATIONS:LEER',
      'SERVICES_SERVICES:LEER',
      'SERVICES_PAYMENT_REQUEST:LEER',
      'SERVICES_DAILY_CUT:LEER',
      'SERVICES_SERVICES:EDITAR',
      'INSURANCE_WORKSHOP:CREAR',
      'INSURANCE_WORKSHOP:LEER',
      'INSURANCE_WORKSHOP:ACTUALIZAR',
      'INSURANCE_WORKSHOP:ELIMINAR',
      'INSURANCE_CLAIMS:LEER',
      'INSURANCE_CLAIMS:EXPORTAR',
      'INSURANCE_CLAIMS:ACTUALIZAR',
      'REPORTS_BRANCHES_DAYS_WHITOUT_SALES:EXPORTAR',
      'MARKETPLACE_MARKETPLACE_ORDERS:LEER',
      'MARKETPLACE_MARKETPLACE_ORDERS:EXPORTAR',
      'MARKETPLACE_MARKETPLACE_ORDERS:CAMBIAR ESTADO',
      'MARKETPLACE_MARKETPLACE_ORDERS:CREAR',
      'MARKETPLACE_MARKETPLACE_ADMIN:LEER',
      'MARKETPLACE_MARKETPLACE_ADMIN:CREAR',
      'MARKETPLACE_MARKETPLACE_ADMIN:ACTUALIZAR',
      'MARKETPLACE_MARKETPLACE_ADMIN:ELIMINAR',
      'MARKETPLACE_MARKETPLACE_PRODUCTS:LEER',
      'MARKETPLACE_MARKETPLACE_PRODUCTS:CREAR',
      'MARKETPLACE_MARKETPLACE_PRODUCTS:ACTUALIZAR',
      'MARKETPLACE_MARKETPLACE_PRODUCTS:ELIMINAR',
      'MARKETPLACE_MARKETPLACE_INVENTORY:LEER',
      'MARKETPLACE_MARKETPLACE_INVENTORY:ACTUALIZAR',
      'ALLY_TAX_INFO:LEER',
      'MARKETING_CAMPAIGN:LEER',
      'MARKETING_CAMPAIGN:CREAR',
      'MARKETING_CAMPAIGN:ACTUALIZAR',
      'MARKETING_CAMPAIGN:ELIMINAR',
      'MARKETING_DRAW:LEER',
      'MARKETING_DRAW:CREAR',
      'MARKETING_DRAW:ACTUALIZAR',
      'MARKETING_DRAW:ELIMINAR',
      'MARKETING_CAMPAIGN_PRIZE:LEER',
      'MARKETING_CAMPAIGN_PRIZE:CREAR',
      'MARKETING_CAMPAIGN_PRIZE:ACTUALIZAR',
      'MARKETING_CAMPAIGN_PRIZE:ELIMINAR',
      'MARKETING_DRAW_PRIZE:LEER',
      'MARKETING_DRAW_PRIZE:CREAR',
      'MARKETING_DRAW_PRIZE:ACTUALIZAR',
      'MARKETING_DRAW_PRIZE:ELIMINAR'
    ],
    photo: 'user/user_68b5d5e162af0680241107.jpeg',
    isLinked: true,
    requireLink: true,
    hasBranchOfficeLocation: true,
    canAssignMiscellaneous: true,
    isWeppa: true,
    hasMarketplace: false
  }
}
